import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { isTrash } from '../../helpers/App';
import { getDefaultSortParams, goalSortSetting } from '../../helpers/Sort';

import SaveSort from './SaveSort';

const Sort = ({
  orderby,
  order,
  search,
  collection,
  setOrder,
  size,
  sort,
  hideSave,
}) => {
  const intl = useIntl();
  const [defaultSort, setDefaultSort] = useState(sort || getDefaultSortParams('files'));

  const goalSortSettingValue = goalSortSetting(orderby, order);

  return (
    <>
      {!hideSave && (
        <SaveSort
          scope="files"
          defaultSort={defaultSort}
          handleDefaultSort={setDefaultSort}
          orderby={orderby}
          order={order}
          goalSortSettingValue={goalSortSettingValue}
        />
      )}
      <UncontrolledDropdown>
        <DropdownToggle
          className="transparent-button"
          id="SortDropdown"
          {...(size ? { size } : {})}
          aria-label={intl.formatMessage({ defaultMessage: 'Sort' })}
        >
          <i className="fal fa-arrow-down-arrow-up" />
        </DropdownToggle>
        <UncontrolledTooltip target="SortDropdown" fade={false} placement="top" boundariesElement="body">
          {intl.formatMessage({ defaultMessage: 'Sort' })}
          {goalSortSettingValue && (
            <>
              {': '}
              {goalSortSettingValue.label}
            </>
          )}
        </UncontrolledTooltip>
        <DropdownMenu>
          {search && (
            <DropdownItem
              active={orderby === 'relevance'}
              onClick={() => {
                setOrder('relevance', 'asc');
              }}
            >
              {intl.formatMessage({ defaultMessage: 'Relevance' })}
            </DropdownItem>
          )}
          {(collection && !collection.smart) && (
            <DropdownItem
              active={orderby === 'position'}
              onClick={() => {
                setOrder('position', 'asc');
              }}
            >
              {intl.formatMessage({ defaultMessage: 'Custom (re-ordered)' })}
            </DropdownItem>
          )}
          <DropdownItem
            active={orderby === 'original_datetime' && order === 'desc'}
            onClick={() => {
              setOrder('original_datetime', 'desc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Newest (creation date)' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'created_at' && order === 'desc'}
            onClick={() => {
              setOrder('created_at', 'desc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Newest (upload date)' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'original_datetime' && order === 'asc'}
            onClick={() => {
              setOrder('original_datetime', 'asc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Oldest (creation date)' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'created_at' && order === 'asc'}
            onClick={() => {
              setOrder('created_at', 'asc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Oldest (upload date)' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'likes'}
            onClick={() => {
              setOrder('likes', 'desc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Favorites' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'size' && order === 'asc'}
            onClick={() => {
              setOrder('size', 'asc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Size (smallest first)' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'size' && order === 'desc'}
            onClick={() => {
              setOrder('size', 'desc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Size (larger first)' })}
          </DropdownItem>
          {isTrash() && (
            <>
              <DropdownItem
                active={orderby === 'deleted_at' && order === 'asc'}
                onClick={() => {
                  setOrder('deleted_at', 'asc');
                }}
              >
                {intl.formatMessage({ defaultMessage: 'Days left in trash (asc)' })}
              </DropdownItem>
              <DropdownItem
                active={orderby === 'deleted_at' && order === 'desc'}
                onClick={() => {
                  setOrder('deleted_at', 'desc');
                }}
              >
                {intl.formatMessage({ defaultMessage: 'Days left in trash (desc)' })}
              </DropdownItem>
            </>
          )}
          <DropdownItem divider />
          <DropdownItem
            active={orderby === 'name' && order === 'asc'}
            onClick={() => {
              setOrder('name', 'asc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'A-Z' })}
          </DropdownItem>
          <DropdownItem
            active={orderby === 'name' && order === 'desc'}
            onClick={() => {
              setOrder('name', 'desc');
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Z-A' })}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

Sort.propTypes = {
  orderby: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  search: PropTypes.string,
  collection: PropTypes.object,
  setOrder: PropTypes.func.isRequired,
  size: PropTypes.string,
  sort: PropTypes.array,
  hideSave: PropTypes.bool,
};

Sort.defaultProps = {
  collection: null,
  search: null,
  size: null,
  sort: null,
  hideSave: false,
};

export default Sort;
